import React from 'react'
import { Route, Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useHasSitesOnProduction } from 'store'
import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'
import EmptyScreen from 'packages/ui/EmptyScreen'

import Traffic from './Traffic'
import Coupons from './Coupons'
import Purchases from './Purchases'
import Chromecasts from './Chromecasts'
import Customers, {Card as CustomerCard} from './Customers'
import ProductAnalytics from 'pages/ProductAnalytics'

const Layout = ({children}) => {
  const {t} = useTranslation()
  const hasSitesOnProduction = useHasSitesOnProduction()

  return hasSitesOnProduction
    ? children
    : <EmptyScreen icon="square-poll-vertical">{t('ui_elements.service_soon')}</EmptyScreen>
}

export const StatsRoutes = ({ path = '/stats' }) => [
  <Route path={path} key="stats">
    <Route path="" element={<Navigate to="usage" />} />
    <Route
      path="usage"
      key="stats-usage"
      element={
        <RouteGuard requiredRoles={['statistic_ssid']}>
          <Layout>
            <Traffic />
          </Layout>
        </RouteGuard>
      }
    />
    <Route
      path="purchases"
      key="stats-purchases"
      element={
        <RouteGuard requiredRoles={['statistic_purchases']}>
          <Layout>
            <Purchases />
          </Layout>
        </RouteGuard>
      }
    />
    <Route
      path="codes"
      key="stats-codes"
      element={
        <RouteGuard requiredRoles={['statistic_coupons']}>
          <Layout>
            <Coupons />
          </Layout>
        </RouteGuard>
      }
    />
    <Route
      path="chromecasts"
      key="stats-chromecasts"
      element={
        <RouteGuard requiredRoles={['statistic_chromecast']}>
          <Layout>
            <Chromecasts />
          </Layout>
        </RouteGuard>
      }
    />
    <Route
      path="customers"
      key="stats-customers"
      element={
        <RouteGuard requiredRoles={['statistic_customers']}>
          <Layout>
            <Customers />
          </Layout>
        </RouteGuard>
      }
    >
      <Route
        path={':id'}
        key={'stats-customers-detail'}
        element={<CustomerCard />}
      />
    </Route>
    <Route
      path="product-analytics"
      key="stats-product-analytics"
      element={
        <RouteGuard requireAdmin>
          <ProductAnalytics />
        </RouteGuard>
      }
    />
  </Route>,
]

export default StatsRoutes
